import axiosInstance from '../config/axios';

// ──────────────────────────────────────────────
// Community APIs
// ──────────────────────────────────────────────

/**
 * Fetch all communities with optional filters
 * @param {{ search?: string, type?: string, category?: string }} params
 */
export const getCommunitiesApi = (params = {}) =>
  axiosInstance.get('/get-community', { params }).then((res) => res.data);

/**
 * Fetch a single community by ID
 * @param {string} id
 */
export const getCommunityByIdApi = (id) =>
  axiosInstance.get(`/api/communities/${id}`).then((res) => res.data);

/**
 * Fetch all categories
 */
export const getCategoriesApi = () =>
  axiosInstance.get('/categories').then((res) => res.data);
